/* @generated from adl module ferovinum.datacontracts.deal */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface DealRawRecord {
  id: common_strings.StringNE;
  organisationId: common_strings.StringNE;
  dealNumber: common_strings.StringNE;
  dealDate: common.LocalDate;
  locale: common_strings.StringNE;
  currency: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeDealRawRecord(
  input: {
    id: common_strings.StringNE,
    organisationId: common_strings.StringNE,
    dealNumber: common_strings.StringNE,
    dealDate: common.LocalDate,
    locale: common_strings.StringNE,
    currency: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): DealRawRecord {
  return {
    id: input.id,
    organisationId: input.organisationId,
    dealNumber: input.dealNumber,
    dealDate: input.dealDate,
    locale: input.locale,
    currency: input.currency,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const DealRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.deal","decl":{"annotations":[{"value":{"datasetName":"raw_deal"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"dealNumber","default":{"kind":"nothing"},"name":"dealNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"dealDate","default":{"kind":"nothing"},"name":"dealDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"locale","default":{"kind":"nothing"},"name":"locale","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"DealRawRecord","version":{"kind":"nothing"}}};

export const snDealRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.deal", name:"DealRawRecord"};

export function texprDealRawRecord(): ADL.ATypeExpr<DealRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snDealRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.deal.DealRawRecord" : DealRawRecord_AST
};
